import React, { Fragment } from "react";
import Formatters from "../../shared/utils/Formatters";

export default function LoanSummary({ loan_plan }) {
  const {
    disbursed_amount = 0,
    is_disbursed,
  } = loan_plan;

  function bankAccountDetails(loanPlan) {
    let { bank_name, account_name, account_number } = loanPlan;

    const bankName = bank_name ? bank_name : "To be filled after submission and verification of cheque";
    const accountName = account_name ? account_name : "To be filled after submission and verification of cheque";
    const accountNumber = account_number ? account_number : "To be filled after submission and verification of cheque";

    return {
      bankName,
      accountName,
      accountNumber,
    }
  }

  return (
    <Fragment>
      <div className="ds-card _noTopMargin">
        {!is_disbursed ?
          <section className="cardSection _withColumns _dataSet">
            <div className="text">
              <h1 className="subhead">Loan Summary</h1>
              <p className="byline">We will be disbursing the following amount to this account in 1 to 2 days. Kindly contact us if there's correction needed to be done before proceeding.</p>
            </div>
            <div className="dataSummary">
              <small className="preamble">Amount to Receive</small>
              <h2 className="headline -primary">{Formatters.currency({ amount: disbursed_amount })}</h2>
            </div>
          </section>
          : null
        }
        <section className="sectionTitle">{!is_disbursed ? 'Disbursing To' : 'Disbursed To'}</section>
        <section className="cardSection">
          <div className="ds-dataSet --block">
            <div className="ds-data">
              <small className="dataName">Bank</small>
              <p className="data" data-test="bank_name">{bankAccountDetails(loan_plan).bankName}</p>
            </div>
            <div className="ds-data">
              <small className="dataName">Account Name</small>
              <p className="data" data-test="bank_account_name">{bankAccountDetails(loan_plan).accountName}</p>
            </div>
            <div className="ds-data">
              <small className="dataName">Account Number</small>
              <p className="data emphasize" data-test="bank_account_number">{bankAccountDetails(loan_plan).accountNumber}</p>
            </div>
          </div>
        </section>
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/features/loans/components/LoanSummary.js